
define('text!modules/targeting/siteList/templates/bin_header.html',[],function () { return '<div class="column header recency">\n    <div class="header-c"><!--recency--></div>\n</div>';});

